import { LOCATIONS_ACTIONS } from './locations.types'

/**
 * @param {import('./locations.types').LocationsSlice['status']} payload
 * @returns {import('./locations.types').LocationsStatusAction}
 */
export const setLocationsStatusAction = payload => ({ type: LOCATIONS_ACTIONS.SET_LOCATIONS_STATUS, payload })

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./locations.types').LocationsErrorsAction}
 */
export const setLocationsErrorsAction = payload => ({ type: LOCATIONS_ACTIONS.SET_LOCATIONS_ERRORS, payload })

/**
 * @param {import('./locations.types').LocationOption[]} payload
 * @returns {import('./locations.types').LocationOptionsAction}
 */
export const setLocationOptionsAction = payload => ({ type: LOCATIONS_ACTIONS.SET_LOCATION_OPTIONS, payload })
